import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';

const LANGS = ['ko', 'en', 'ja', 'ru', 'de'];
const BASE = 'https://saju247.kr';

/**
 * Injects hreflang alternate link tags + html lang attribute for SEO.
 * Each language variant uses ?lang=xx query parameter.
 */
export default function SeoHreflang() {
  const { lang } = useI18n();
  const { pathname } = useLocation();

  const links = LANGS.map(l => ({
    rel: 'alternate',
    hrefLang: l,
    href: `${BASE}${pathname}?lang=${l}`,
  }));
  links.push({
    rel: 'alternate',
    hrefLang: 'x-default',
    href: `${BASE}${pathname}`,
  });

  return (
    <Helmet htmlAttributes={{ lang }}>
      {links.map(l => (
        <link key={l.hrefLang} rel={l.rel} hrefLang={l.hrefLang} href={l.href} />
      ))}
    </Helmet>
  );
}
